import { invalidObjectsAPI } from "@/views/InvalidObjects/services/api";

export const getInvalidObjects = async () => {
  const res = await invalidObjectsAPI.read();
  return res?.data || [];
};

export const getTableForCreateForeignKey = async () => {
  const res = await invalidObjectsAPI.readTableForForeignKey();
  return res?.data || [];
};

export const getTableForCreateTrigger = async () => {
  const res = await invalidObjectsAPI.readTableForTrigger();
  return res?.data || [];
};

export const getFuncStat = async (func_name = "") => {
  const res = await invalidObjectsAPI.readFuncStat(func_name);
  return res?.data || [];
};

